async function init(){
    const signInFormEl = document.getElementById("invoiceSignInForm");
    if (signInFormEl) {
        const { default: SignInForm } = await import("./modules/signinform.js");
        SignInForm.init();
    }

    // this form should technically always be on the page, but wrapping in check just in case
    const guestFormEl = document.getElementById("invoiceGuestForm");
    if (guestFormEl) {
        const { default: GuestForm } = await import("./modules/guestform.js");
        GuestForm.init();
    }
}  
	
await init();